module.exports = __webpack_public_path__ + "img/icon-edit.a7a365f3.svg";